export default "__VITE_ASSET__DX72srpT__"